import { render } from "./BForm.vue?vue&type=template&id=607c7d0c&ts=true"
import script from "./BForm.vue?vue&type=script&lang=ts"
export * from "./BForm.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__